import { BUILD_PHASE } from "../../../utils/sparkflow-constants";
export function formatColumnLabel(key) {
    const readable = key.replace(/_/g, ' ');
    return readable.charAt(0).toUpperCase() + readable.slice(1);
}
export function isCompletedPhase(phase) {
    return phase === BUILD_PHASE.COMPLETED;
}
export const initialBuildState = {
    phase: BUILD_PHASE.INITIALIZING,
    progress: 0,
    previewData: null,
};
export function buildReducer(state, action) {
    switch (action.type) {
        case 'START_BUILDING':
            if (state.phase !== BUILD_PHASE.INITIALIZING)
                return state;
            return { ...state, phase: BUILD_PHASE.BUILDING };
        case 'SET_PROGRESS':
            return { ...state, progress: action.progress };
        case 'GENERATING_PREVIEW':
            return { ...state, phase: BUILD_PHASE.GENERATING_PREVIEW };
        case 'PREVIEW_READY':
            return {
                ...state,
                phase: BUILD_PHASE.PREVIEW_READY,
                previewData: action.previewData,
            };
        case 'BUILD_COMPLETE':
            return { ...state, phase: BUILD_PHASE.COMPLETED, progress: 100 };
        default:
            return state;
    }
}
//# sourceMappingURL=build-helpers.js.map